const Entity = require('./entity')

class EntityShared extends Entity {
  constructor(document) {
    super(document)
    this.IdCompany = document.IdCompany
  }
}

module.exports = EntityShared
